<script>
  export let close;
</script>

<div>
  <a href="#" on:click="{close}">Skip intro</a>
</div>

<style>
  div {
    height: 2rem;
    text-align: center;
  }
  a:hover {
    color: darkorange;
  }
</style>
